<div class="modal__header">
  <span class="title">{{ isEditMode ? 'Редактирование правила' : 'Создание правила' }}</span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()"></div>
</div>

<div class="modal__body create-work-restriction-rule">
  <div class="create-work-restriction-rule__row" *ngIf="!isEditMode">
    <div class="create-work-restriction-rule__label title title-vertical title--s title--required">Участок</div>
    <div class="create-work-restriction-rule__control">
      <div class="create-work-restriction-rule__static-select">
        {{ sectorTitle || '-' }}
      </div>
    </div>
  </div>

  <div class="create-work-restriction-rule__row">
    <div class="create-work-restriction-rule__label title title-vertical title--s title--required">Район</div>
    <div class="create-work-restriction-rule__control">
      <app-select-multiple
        [items]="districts"
        [initBy]="selectedDistricts"
        [initByKey]="'id'"
        [textKey]="'name'"
        [defaultText]="'Выберите значение'"
        (callback)="onDistrictsChange($event)"
      ></app-select-multiple>
    </div>
  </div>

  <div class="create-work-restriction-rule__row">
    <div class="create-work-restriction-rule__label title title-vertical title--s title--required">Тип работ</div>
    <div class="create-work-restriction-rule__control">
      <app-select-multiple
        [items]="workTypes"
        [initBy]="selectedWorkTypes"
        [initByKey]="'id'"
        [textKey]="'name'"
        [defaultText]="'Выберите значение'"
        (callback)="onWorkTypesChange($event)"
      ></app-select-multiple>
    </div>
  </div>

  <div class="delimiter delimiter--size-1 delimiter--gray-bright mt-16 mb-16"></div>

  <div class="create-work-restriction-rule__row create-work-restriction-rule__row--radio">
    <div class="create-work-restriction-rule__label title title-vertical title--s">Тип правила</div>
    <div class="create-work-restriction-rule__control">
      <div class="grid grid--gap-32">
        <div class="grid__box grid__box--size-min">
          <app-radio-button>
            <input type="radio" name="ruleType" value="schedule" [checked]="ruleType === 'schedule'" (change)="ruleType = 'schedule'" />
            <radio-button-text>По расписанию</radio-button-text>
          </app-radio-button>
        </div>
        <div class="grid__box grid__box--size-min">
          <app-radio-button>
            <input type="radio" name="ruleType" value="day" [checked]="ruleType === 'day'" (change)="ruleType = 'day'" />
            <radio-button-text>День в день</radio-button-text>
          </app-radio-button>
          <span class="create-work-restriction-rule__hint-icon" title="Подсказка">
            <app-icon [glyph]="'round-e-help'" [size]="'14'" [color]="'gray-dark'"></app-icon>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="create-work-restriction-rule__row">
    <div class="create-work-restriction-rule__label title title-vertical title--s title--required">Дни недели</div>
    <div class="create-work-restriction-rule__control">
      <div class="create-work-restriction-rule__weekdays">
        <div class="create-work-restriction-rule__weekday" *ngFor="let day of weekdays">
          <app-checkbox>
            <input type="checkbox" [checked]="day.checked" (change)="day.checked = $event.target.checked" />
            <checkbox-text>&nbsp;</checkbox-text>
          </app-checkbox>
          <div class="create-work-restriction-rule__weekday-text">{{ day.short }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="create-work-restriction-rule__row">
    <div class="create-work-restriction-rule__label title title-vertical title--s title--required">Временной интервал</div>
    <div class="create-work-restriction-rule__control">
      <div class="create-work-restriction-rule__time-wrapper">
        <div class="create-work-restriction-rule__time-range">
          <input
            class="input-text create-work-restriction-rule__time"
            [class.create-work-restriction-rule__time--error]="timeFrom && !isTimeValid(timeFrom)"
            type="text"
            [(ngModel)]="timeFrom"
            placeholder="00:00"
          />
          <span class="create-work-restriction-rule__dash">—</span>
          <input
            class="input-text create-work-restriction-rule__time"
            [class.create-work-restriction-rule__time--error]="timeTo && !isTimeValid(timeTo)"
            type="text"
            [(ngModel)]="timeTo"
            placeholder="00:00"
          />
        </div>
        <div class="create-work-restriction-rule__time-error" *ngIf="timeError">
          {{ timeError }}
        </div>
      </div>
    </div>
  </div>

  <div class="delimiter delimiter--size-1 delimiter--gray-bright mt-16 mb-16"></div>

  <div class="create-work-restriction-rule__row create-work-restriction-rule__row--radio">
    <div class="create-work-restriction-rule__label title title-vertical title--s">Срок действия</div>
    <div class="create-work-restriction-rule__control">
      <div class="grid grid--gap-32">
        <div class="grid__box grid__box--size-min">
          <app-radio-button>
            <input type="radio" name="validityType" value="forever" [checked]="validityType === 'forever'" (change)="validityType = 'forever'" />
            <radio-button-text>Бессрочно</radio-button-text>
          </app-radio-button>
        </div>
        <div class="grid__box grid__box--size-min">
          <app-radio-button>
            <input type="radio" name="validityType" value="period" [checked]="validityType === 'period'" (change)="validityType = 'period'" />
            <radio-button-text>В указанный период</radio-button-text>
          </app-radio-button>
        </div>
      </div>
    </div>
  </div>

  <div class="create-work-restriction-rule__row" [class.create-work-restriction-rule__row--disabled]="validityType !== 'period'">
    <div class="create-work-restriction-rule__label title title-vertical title--s title--required">Период действия</div>
    <div class="create-work-restriction-rule__control">
      <div class="create-work-restriction-rule__period">
        <span class="create-work-restriction-rule__period-label">с</span>
        <div class="create-work-restriction-rule__period-picker">
          <app-date-time-picker
            [initDate]="periodFromInitDate"
            [datepickerName]="'wrPeriodFrom'"
            [placeholder]="'ДД.ММ.ГГГГ'"
            [isShowTimepicker]="false"
            [isDisabled]="validityType !== 'period'"
            (dateCallback)="onPeriodFromChange($event)"
          ></app-date-time-picker>
        </div>
        <span class="create-work-restriction-rule__period-label">по</span>
        <div class="create-work-restriction-rule__period-picker">
          <app-date-time-picker
            [initDate]="periodToInitDate"
            [datepickerName]="'wrPeriodTo'"
            [placeholder]="'ДД.ММ.ГГГГ'"
            [isShowTimepicker]="false"
            [isDisabled]="validityType !== 'period'"
            (dateCallback)="onPeriodToChange($event)"
          ></app-date-time-picker>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal__footer">
  <div class="modal__footer-action" *ngIf="isEditMode">
    <button class="button" type="button" (click)="onDelete()">Удалить правило</button>
  </div>
  <div class="modal__footer-action">
    <button class="button button--orange" type="button" (click)="onSave()" [disabled]="!isFormValid || !hasChanges">Сохранить</button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" (click)="activeModal.dismiss()">Закрыть</a>
  </div>
</div>

<!-- Delete Confirmation Dialog -->
<div class="delete-confirmation-overlay" *ngIf="showDeleteConfirmation">
  <div class="delete-confirmation-dialog">
    <div class="delete-confirmation-dialog__header">
      <span class="delete-confirmation-dialog__title">Удалить правило?</span>
      <div class="modal-close color-gray-dark" (click)="onCancelDelete()"></div>
    </div>
    <div class="delete-confirmation-dialog__body">
      <p>Правило будет безвозвратно удалено.</p>
    </div>
    <div class="delete-confirmation-dialog__footer">
      <button class="button" type="button" (click)="onConfirmDelete()">Удалить</button>
      <a class="link link--dotted-blue-dark" (click)="onCancelDelete()">Отменить</a>
    </div>
  </div>
</div>
